var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsFilledSearch24Px(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8C6BE8B5-9BC1-4261-909A-ABF68A7E1032") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDF08-Icon-Color",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.779709,17.8330241 L16.6643882,14.7177033 C16.523777,14.5770921 16.3331706,14.4989747 16.1331901,14.4989747 L15.6238649,14.4989747 C16.4862806,13.3959574 16.9987306,12.0085929 16.9987306,10.4993653 C16.9987306,6.90909091 14.0896397,4 10.4993653,4 C6.90909091,4 4,6.90909091 4,10.4993653 C4,14.0896397 6.90909091,16.9987306 10.4993653,16.9987306 C12.0085929,16.9987306 13.3959574,16.4862806 14.4989747,15.6238649 L14.4989747,16.1331901 C14.4989747,16.3331706 14.5770921,16.523777 14.7177033,16.6643882 L17.8330241,19.779709 C18.1267454,20.0734303 18.6016991,20.0734303 18.8922957,19.779709 L19.7765843,18.8954204 C20.0703056,18.6016991 20.0703056,18.1267454 19.779709,17.8330241 Z M10.4993653,14.4989747 C8.29020603,14.4989747 6.49975588,12.7116493 6.49975588,10.4993653 C6.49975588,8.29020603 8.28708134,6.49975588 10.4993653,6.49975588 C12.7085246,6.49975588 14.4989747,8.28708134 14.4989747,10.4993653 C14.4989747,12.7085246 12.7116493,14.4989747 10.4993653,14.4989747 Z",
    id: "Icons/Filled/search_24px",
    fillRule: "nonzero"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsFilledSearch24Px);
export default __webpack_public_path__ + "static/media/Icons_Filled_search_24px.ac41f3fa.svg";
export { ForwardRef as ReactComponent };